import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';

import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { AppWindow } from '@app/entities/app-window';
import { dimensionImageProxy } from '@ux/mappers/dimension-image.mapper';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { ButtonIconSize } from '@design-system/components/molecules/button-icon/entities/button-icon.types';
import {
  TypographyColor,
  TypographyFontFamily,
  TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';

declare const window: AppWindow;
@Component({
  selector: 'app-image-gallery-mobile',
  templateUrl: './image-gallery-mobile.component.html',
  styleUrls: ['./image-gallery-mobile.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelGalleryMobileComponent {

  @Input() isEmulateRoute: boolean = false;
  @Input() images: string[] = [];
  @Input() isOpen: boolean = false;

  @ViewChild('allImages') public allImages: ElementRef;
  @ViewChild('mainImage') public mainImage: ElementRef;

  private heightImagePx: number = 184;

  public quantityImages: number = 5;
  public currentSlide: number;

  public imageSize = ImageSize.None;
  public buttonSize = ButtonIconSize;

  public readonly icon = Icon;
  public readonly iconColor = IconFillColor;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;
  
  constructor(
    private domManipulateService: DomManipulateService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  get imagesOnCarousel(): string[] {
    return this.images?.length < this.quantityImages ? this.images : this.images?.slice(0, 5);
  }

  get dimensionImage(): string {
    let result;
    if (typeof window !== 'undefined') {
      result = dimensionImageProxy(window, this.heightImagePx);
    }
    return result;
  }

  get showOverlay(): boolean {
    return this.currentSlide === this.quantityImages;
  }

  public toggleOpen(): void {
    this.isOpen = !this.isOpen;
    this.mainImage.nativeElement.scrollIntoView();
    setTimeout(() => this.mainImage.nativeElement.scrollTop = 0, 100);
    this.domManipulateService.setBodyScroll(!this.isOpen);
    this.cdr.detectChanges();
  }

  public scrollTop(): void {
    setTimeout(() => this.mainImage.nativeElement.scrollTop = 0, 100);
  }

  public trackById(index: number): number {
    return index;
  }

  public setCurrentSlide(event: number): void {
    this.currentSlide = event;
  }

  public imageWidth(index: number): string {
    return index === 0 ? undefined : '100%';
  }

  public imageHeight(index: number): string {
    return index === 0 ? '184px' : undefined;
  }

}
